import createAxiosInstance from './axiosConfig';
import { GerenteDTO } from '../shared/dto/gerenteDTO';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/gerenteController');

export default class SupervisorService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async listarTodosGerentes(page = 0, size = 10, filtros: any) {
    return await this.axios.post(`/listarTodosGerentes`, filtros, {
      params: { page, size }
    });
  };

  async listarTodosGerentesPorRole() {
    return await this.axios.get(`/listarTodosGerentesPorRole`);
  };


  async listarTodosGerentesAtivos() {
    return await this.axios.get(`/listarTodosGerentesAtivos`);
  };

  async ativarInativarGerente(id: string) {
    return await this.axios.get(`ativarInativarGerente?id=${id}`);
  };

  async listarGerentePorId(id: string) {
    return await this.axios.get(`listarGerentePorId?id=${id}`);
  };

  async incluirAlterarGerente(dto: GerenteDTO) {
    return await this.axios.post(`/incluirAlterarGerente`, dto);
  };

  async listarUsuariosSemGerente(): Promise<any> {
    return await this.axios.get(`/listarUsuariosSemGerente`);
  };

  async getVinculoAtual(usuarioId: string | number): Promise<any> {
    return await this.axios.get(`/getVinculoPorUsuarioId?usuarioId=${usuarioId}`);
  }

}